import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.generated = false
    this.intervalId = setInterval(this.generate.bind(this), 5000)
  }

  generate() {
    if (this.generated) return

    const data = document.getElementById("qr-data").value

    if (data.length > 256) {
      alert("The data is too long to generate a QR code.")
      clearInterval(this.intervalId)
      return
    }

    fetch(`/qr_code?data=${encodeURIComponent(data)}`)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob)
        document.getElementById("qr-code-container").innerHTML = `<img src="${url}">`
        this.generated = true
        clearInterval(this.intervalId) // Stop the interval
      })
  }

  disconnect() {
    clearInterval(this.intervalId) // Clear the interval when the controller is disconnected
  }
}